import React from "react";
import "./Loader.css";
import loaderGif from "../assets/imges/loader.gif"; // <-- apni file yaha rakhna

const Loader = () => {
    return (
        <div className="loader-container">
            <img src={loaderGif} alt="Loading..." className="loader-img" />
        </div>
    );
};

export default Loader;
